import Vue from 'vue'
import Router from 'vue-router'
import jwtDecode from 'jwt-decode'
import axios from 'axios'
const Login = () => import('@/views/login')
const Admin = () => import('@/views/admin/admin')
const AdminDashboard = () => import('@/views/admin/dashboard')
const AdminCampaigns = () => import('@/views/admin/campaigns/campaigns')
const AdminOpenCampaigns = () => import('@/views/admin/campaigns/open-campaigns')
const AdminOrganizations = () => import('@/views/admin/organizations/organizations')
const AdminSubscriberDb = () => import('@/views/admin/subscriber-db/subscriber-db')
const AdminUsers = () => import('@/views/admin/users/users')
const AdminReports = () => import('@/views/admin/campaigns/reports')
const AdminSettings = () => import('@/views/admin/settings/')
const AdminCampaignForm = () => import('@/views/admin/campaigns/form')
const CurrentStep = () => import('@/components/campaigns/current-step')
const Recovery = () => import('@/components/recovery')

Vue.use(Router)

function requireAuth (to, from, next) {
  let token = localStorage.getItem('feathers-jwt')
  if (token && jwtDecode(token).exp) {
    const exp = new Date(jwtDecode(token).exp * 1000)
    if (exp < (new Date())) {
      localStorage.removeItem('feathers-jwt')
      delete axios.defaults.headers.common['Authorization']
      token = null
    }
  }

  const query = { redirect: to.path }
  if (to.query.hl) {
    query.hl = to.query.hl
  }

  if (!token) {
    next({
      path: '/login',
      query
    })
  } else {
    next()
  }
}

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/admin'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/admin',
      component: Admin,
      beforeEnter: requireAuth,
      children: [
        {
          path: '/',
          name: 'adminDashboard',
          component: AdminDashboard
        },
        {
          path: 'organizations/',
          name: 'adminOrganizations',
          component: AdminOrganizations,
          props: true
        },
        {
          path: 'organizations/:type/new',
          name: 'adminOrganizationForm',
          component: AdminOrganizations,
          props: true
        },
        {
          path: 'organizations/:id/:type/edit',
          name: 'adminOrganizationEdit',
          component: AdminOrganizations,
          props: true
        },
        {
          path: 'subscribersdb',
          name: 'adminSubscriberDb',
          component: AdminSubscriberDb,
          props: true
        },
        {
          path: 'subscribersdb/:type/new',
          name: 'adminSubscriberDbForm',
          component: AdminSubscriberDb,
          props: true
        },
        {
          path: 'subscribersdb/:id/:type/edit',
          name: 'adminSubscriberDbEdit',
          component: AdminSubscriberDb,
          props: true
        },
        {
          path: 'users/',
          name: 'adminUsers',
          component: AdminUsers,
          props: true
        },
        {
          path: 'users/:type/new',
          name: 'adminUserForm',
          component: AdminUsers,
          props: true
        },
        {
          path: 'users/:id/:type/edit',
          name: 'adminUserEdit',
          component: AdminUsers,
          props: true
        },
        {
          path: 'campaigns',
          name: 'adminCampaigns',
          component: AdminCampaigns
        },
        {
          path: 'campaigns/:id/reports/:dbid/:currentPage/:pageSize/:searchTerm?',
          name: 'adminReports',
          component: AdminReports,
          props: true
        },
        {
          path: 'campaigns/new',
          component: AdminCampaignForm,
          children: [
            {
              path: ':_id',
              name: 'currentStep',
              component: CurrentStep
            }
          ]
        },
        {
          path: 'campaigns/:id/edit',
          component: AdminCampaignForm,
          children: [
            {
              path: ':_id',
              name: 'editCurrentStep',
              component: CurrentStep
            }
          ]
        },
        {
          path: 'opencampaigns',
          name: 'openCampaigns',
          component: AdminOpenCampaigns
        },
        {
          path: 'settings',
          name: 'adminSettings',
          component: AdminSettings
        }
      ]
    },
    {
      path: '/users/:userId/resetlink/:rlink',
      name: 'recovery',
      component: Recovery,
      props: true
    }
  ]
})

router.beforeEach((to, from, next) => {
  // use the language from the routing param or default language
  let language = to.query.hl
  if (language) {
    console.log(Vue.i18n.set.toString())
    Vue.i18n.set(language)
  }
  // set the current language for vuex-i18n. note that translation data
  // for the language might need to be loaded first
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js